package com.anjuros.website.templates.template6.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template6.modules.Template6Review
import com.anjuros.website.templates.template6.modules.Template6Theme
import com.anjuros.website.templates.template6.util.Template6Constants.FONT_FAMILY
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template6TestimonialCard(
    modifier: Modifier = Modifier,
    testimonial: Template6Review
){

    Box(modifier= modifier
        .margin(20.px)
        .backgroundColor(Colors.White)
        .boxShadow(
            offsetY = 6.px,
            blurRadius = 20.px,
            color = rgba(0, 0, 0, 0.4)
        )
        .padding(20.px)){


        Column {
            Row(modifier= Modifier
                .fillMaxWidth()
                .margin(bottom = 10.px)) {

                Column {
                    P(
                        attrs = Modifier
                            .fillMaxWidth()
                            .margin(topBottom = 0.px)
                            .fontFamily(FONT_FAMILY)
                            .fontSize(18.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Template6Theme.DarkGrey.rgb)
                            .toAttrs()
                    ) {
                        Text(LocalText(testimonial.title))
                    }

                    RatingBar(modifier= Modifier.margin(top=5.px))

                }

            }

            P(
                attrs = Modifier
                    .fillMaxWidth()
                    .margin(topBottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .fontWeight(FontWeight.Normal)
                    .fontStyle(FontStyle.Italic)
                    .color(Colors.Gray)
                    .toAttrs()
            ) {
                Text(LocalText(testimonial.review))
            }

        }
    }
}

@Composable
fun RatingBar(modifier: Modifier = Modifier){
    Row(modifier=modifier){
        repeat(5){
            Image(
                modifier = Modifier
                    .size(16.px)
                    .margin(right=if(it!=4) 2.px else 0.px),
                src = "star_icon.svg",
                alt = "Star icon"
            )
        }
    }
}